export const MPAASLINKS = {
    pro:'https://api.txx.taikanglife.com/platform/isales-platform-home/mpaas/setting/appversion',
    dev:'https://apitest.txx.taikanglife.com/platform/isales-platform-home/mpaas/setting/appversion',
    method:'POST'
}

export const ISALESLINKS = {
    pro:'https://isales.taikang.com/isales/sys/currentVer',
    dev:'https://isaleuat.taikang.com/isales/sys/currentVer',
    method:'GET'
}

export const HELPCENTERLINKS = {
    pro:'https://isales.taikang.com/static/bzzx/pages/bzzx/bzzx.html',
    dev:'https://isaleuat.taikang.com/static/bzzx/pages/bzzx/bzzx.html'
}

export const VERSIONINTROLINKS={
    pro:'https://isales.taikang.com/static/bzzx/pages/gnjs/gnjs.html',
    dev:'https://isaleuat.taikang.com/static/bzzx/pages/gnjs/gnjs.html'
}

export const SIGNATURE={
    pro:'/hwp-weixin-mp/v1/tickets/api-ticket/sign',
    dev:'/hwp-weixin-mp/v1/tickets/api-ticket/sign',
    // dev:'/tkmap/wechat/jsapi/getSignature.do'
}
export const MDS = {
    pro:'https://mgs.txx.taikanglife.com/isales-platform-mds/baseInstall/queryBase',
    dev:'https://yuns-uat.it.taikang.com/isales-platform-mds/baseInstall/queryBase',
    method:'GET'

}